<template>
  <md-card>
    <md-card-header class="md-layout">
      <div class="md-layout-item md-size-70 md-small-size-100">
        <h4>Conceptos del siniestro</h4>
      </div>
      <div
        v-if="
          !disableAll &&
          $can('change', 'Quantification', 'quantification') &&
          quantityChangedConcepts
        "
        class="md-layout-item md-size-30 md-layout md-alignment-center-right md-small-size-100"
      >
        <md-button class="md-info md-simple" @click="saveChanges">
          <md-icon>save</md-icon>Guardar cambios
        </md-button>
        <md-button @click="resetMarks" class="md-just-icon md-info md-simple">
          <md-icon>cached</md-icon>
          <md-tooltip>Deshacer selección</md-tooltip>
        </md-button>
      </div>
    </md-card-header>
    <div style="padding: 0 15px">
      <md-table
        v-model="concepts"
        md-sort.sync="id"
        md-sort-order="asc"
        md-card
        class="table-hover"
      >
        <md-table-row slot="md-table-row" slot-scope="{ item, index }">
          <md-table-cell md-label="Código">
            <strong>{{ item.code }}</strong>
          </md-table-cell>
          <md-table-cell md-label="Nombre">{{ item.name }}</md-table-cell>
          <md-table-cell md-label="Precio unitario">
            {{
            getCurrency(item)
            }}
          </md-table-cell>
          <md-table-cell md-label="Cantidad">{{ item.quantity }}</md-table-cell>
          <md-table-cell md-label="Cantidad a reparar">
            <div class="outlined-field-dense">
              <md-field>
                <md-input
                  :disabled="
                    processIsGreaterThan('RS (VR)') ||
                    item.canNotBeRepaired ||
                    item.notToDo
                  "
                  :value="item.quantityExecuted"
                  type="number"
                  step="0.000001"
                  @input="setValidNumber($event, item, index)"
                ></md-input>
              </md-field>
            </div>
          </md-table-cell>
          <md-table-cell md-label="No ejecutar">
            <md-checkbox
              style="margin: 0"
              :disabled="
                processIsGreaterThan('RS (VR)') ||
                !!item.damagePhotos.length ||
                !!item.files.length
              "
              @change="markAsNotToDo(item, index)"
              v-model="item.notToDo"
            ></md-checkbox>
            <md-tooltip>Marcar para no ejecutar</md-tooltip>
          </md-table-cell>
          <md-table-cell md-label="No se repara">
            <md-checkbox
              style="margin: 0"
              :disabled="
                processIsGreaterThan('RS (VR)') ||
                !!item.damagePhotos.length ||
                !!item.files.length
              "
              @change="markAsNotToRepair(item, index)"
              v-model="item.canNotBeRepaired"
            ></md-checkbox>
            <md-tooltip>Marcar que no es posible reparar</md-tooltip>
          </md-table-cell>

          <md-table-cell md-label="Archivos">
            <md-button
              :disabled="!canAddFilesConcepts(item) || disableAll"
              class="md-just-icon"
              :class="{ 'md-info': canAddFilesConcepts(item) }"
              @click="$emit('selectedConcept', item)"
            >
              <md-icon>list</md-icon>
              <md-tooltip>Ver todos los archivos</md-tooltip>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <h4 v-if="AllConceptsNotDo" class="text-warning" style="margin: 10px">
        <md-icon style="margin-right: 10px">info</md-icon>La cuantificación no
        contiene conceptos por realizar,
        <strong>el siniestro avanzará directamente a ADO</strong>
      </h4>
    </div>
  </md-card>
</template>

<script>
import ConceptSelector from "@/pages/RoadSinisters/File/Quantification/ConceptSelector";

import { cloneDeep } from "lodash";
import processCalculationsMixin from "@/pages/RoadSinisters/File/mixins/processCalculations";

export default {
  name: "ConceptsTable",
  components: { ConceptSelector },
  props: {
    fetchedConcepts: {
      type: Array,
      required: true,
      default: () => [],
    },
    currencies: {
      type: Array,
      required: true,
      default: () => [],
    },
    roadSinister: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    process: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    quantification: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    disableAll: {
      type: Boolean,
      default: false,
    },
    isCP: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [processCalculationsMixin],
  data() {
    return {
      currentConcept: null,
      concepts: [],
      // mapReject: {},
    };
  },
  computed: {
    quantityChangedConcepts() {
      return this.concepts.some((c) => {
        const found = this.fetchedConcepts.find((cc) => cc.id === c.id);
        return found && +c.quantityExecuted !== +found.quantityExecuted;
      });
    },
    pendingChanges() {
      const { quantityChangedConcepts } = this;
      return quantityChangedConcepts;
    },
    existantConcepts() {
      return this.quantification.concepts.map(({ concept: id }) => ({ id }));
    },
    AllConceptsNotDo() {
      return !this.concepts.some((c) => !c.notToDo && !c.canNotBeRepaired);
    },
  },
  methods: {
    resetMarks() {
      const { fetchedConcepts } = this;
      this.concepts = cloneDeep(fetchedConcepts);
    },
    getCurrency({ unitPriceMXN, unitPriceUSD }) {
      if (+unitPriceUSD) {
        const found = this.currencies.find((c) => c.codename === "USD");
        return `${found.symbol}${+unitPriceUSD}`;
      }
      if (+unitPriceMXN) {
        const found = this.currencies.find((c) => c.codename === "MXN");
        return `${found.symbol}${+unitPriceMXN}`;
      }
      return "No hay precio";
    },
    saveChanges() {
      const invalidQuantity = this.concepts.some(
        ({ quantityExecuted, quantity }) => {
          return (
            +quantityExecuted < 0 || (this.isCP && quantityExecuted > quantity)
          );
        }
      );
      if (invalidQuantity) {
        const text = this.isCP
          ? "Menor a cero o mayores a las cantidades de cuantificación"
          : "Menor a cero";
        this.$alertMessage({
          title: "Algunos conceptos tienen cantidades incorrectas",
          text,
        });
        return;
      }
      this.$emit("saveChanges", this.concepts);
    },
    markAsNotToRepair(concept, index) {
      this.$emit(
        "toggleConceptStatus",
        {
          ...concept,
          quantityExecuted: 0,
          notToDo: false,
        },
        index
      );
    },
    markAsNotToDo(concept, index) {
      this.$emit(
        "toggleConceptStatus",
        {
          ...concept,
          quantityExecuted: 0,
          canNotBeRepaired: false,
        },
        index
      );
    },
    setValidNumber(value, item) {
      if (+value <= 0 || !value) {
        item.quantityExecuted = 0;
      } else {
        item.quantityExecuted = +value;
      }
    },
    canAddFilesConcepts({ notToDo, canNotBeRepaired }) {
      return !notToDo && !canNotBeRepaired;
    },
  },
  watch: {
    fetchedConcepts: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal.length) {
          this.concepts = cloneDeep(newVal);
        }
      },
    },
    pendingChanges(newVal) {
      this.$emit("pendingChanges", newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card,
.md-card-content,
.md-card-actions {
  border: none;
  margin: 0;
  box-shadow: none;
}

.md-tooltip {
  word-wrap: break-word;
}
.md-table {
  min-height: 360px;
}
.outlined-field-dense {
  max-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/Lifting/ConceptsTable.vue